import React from 'react';

interface IProps {

}
function NotFoundPage({ }: IProps) {

  return (<>Page Not Found.!!!</>)
}
export default NotFoundPage;